export default __webpack_public_path__ + "static/media/production.e9a06f70.PNG";